/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'

const baseUrl = `invoice`
export default {
  /**
   * @description 获取开票列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceList(data) {
    return request.post(`/${baseUrl}/list`, data)
  },
  /**
   * createInvoiceList
   * @description 创建开票
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  isInvoiceBatch(data) {
    return request.post(`/${baseUrl}/is_batch`, data)
  },
  createInvoiceList(data) {
    return request.post(`/${baseUrl}/create`, data)
  },
  createYTInvoiceList(data) {
    return request.post(`/${baseUrl}/batch_create`, data)
  },
  // 批量下载发票
  batchDownLoadInvoice(data) {
    return request.post(`/${baseUrl}/batch_download`, data)
  },
  /**
   * editInvoice
   * @description 编辑开票信息
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  editInvoice(data) {
    return request.post(`/${baseUrl}/edit`, data)
  },
  /**
   * getInvoiceView
   * @description 查看申请详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceView(data) {
    return request.post(`/${baseUrl}/view`, data)
  },
  /**
   * getInvoiceCategory
   * @description 获取开票类目
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceCategory(data) {
    return request.post(`/${baseUrl}/category`, data)
  },
   /**
   * invoiceSubmit
   * @description 提交在线开票
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceSubmit(data) {
    return request.post(`/${baseUrl}/submit`, data)
  },
  /**
   * invoiceDelete
   * @description 删除
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceDelete(data) {
    return request.post(`/${baseUrl}/delete`, data)
  },
  /**
   * invoiceDetail
   * @description 查看开票详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceDetail(data) {
    return request.post(`/${baseUrl}/detail`, data)
  },
  /**
   * expressDetails
   * @description 查看快递详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  expressDetails(data) {
    return request.post(`/${baseUrl}/express`, data)
  },
  /**
   * viewDataStatistics
   * @description 查看数据统计
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  viewDataStatistics() {
    return request.post(`/${baseUrl}/statistics`, null)
  },
   /**
   * toReview
   * @description 复核
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  toReview(data) {
    return request.post(`/${baseUrl}/review`, data)
  },
  /* 下载压缩包*/
  downZIP(data) {
    return request.post(`/${baseUrl}/download`, data)
  },
  // 劳务派遣待请求的提现订单列表
  laowuTxorderList(data){
	return request.post(`/${baseUrl}/withdraw/order/list`, data)
  },
	// 劳务派遣税局列表
	laborcompanylist(data){
	return request.post(`/${baseUrl}/labor/company/list`, data)
	},
  // 开票充值选择列表
	invoiceRechargeList(data){
    return request.post(`/${baseUrl}/recharge/select`, data)
  },
}